module.exports = __webpack_public_path__ + "05_glasses_red.413440ea.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/nakagawa/male/layer4/05_glasses_red.png
// module id = PGLb
// module chunks = 0